<template>
    <modal name="crop-puzzle" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'modal', 'crop-puzzle', hasBugs && 'has-bugs']" :width="730" :height="'auto'"
        :scrollable="true" :adaptive="true">
        <div class="modal-title">
            {{ $t("photos.crop") }}
        </div>
        <div class="modal-close" v-if="allowClose" @click="close"></div>
        <div class="modal-body">
            <div class="modal-subtitle">
                {{ $t("photos.displayedPuzzle") }}
                :</div>
            <div class="crop-puzzle-wrapper">
                <vue-cropper :viewMode=1 ref="cropper" :src="image" alt="Source Image" :aspectRatio=1 :guides=false
                    :center=false :zoomOnWheel=false :minCropBoxWidth=600 :minCropBoxHeight=600 :background=false
                    class="crop-puzzle-cropper">
                </vue-cropper>
            </div>
            <div class="buttons-row">
                <button v-if="allowClose" @click="close" type="button" class="button-secondary">{{ $t("balanceIn.cancel") }}
                </button>
                <button @click="save" v-if="!loader" class="button">{{ $t("balanceIn.continue") }}
                </button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </modal>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'CropPuzzle',
    props: {
        i18n: Object,
    },
    components: {
        VueCropper
    },
    mixins: [
        checkScroll
    ],
    data() {
        return {
            hasBugs: false,
            loader: false,
            photoId: '',
            image: '',
            album: '',
            currentAlbum: '',
            create: false,
            callback: null,
            allowClose: true
        }
    },
    watch: {
        '$route'(to, from) {
            if (to != from) {
                this.$modal.hide('crop-puzzle');
            }
        }
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.photoId = event.params.id || null;
            this.image = event.params.image;
            this.album = event.params.album;
            this.currentAlbum = event.params.current || null;
            this.create = event.params.create || false;
            this.callback = event.params.callback || null;
            this.allowClose = event.params.allowClose || true;
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        save() {
            let cropped = this.$refs.cropper.getCroppedCanvas().toDataURL();
            //console.log(this.callback)
            if (this.callback) {
                this.callback(cropped);
            } else {
                this.loader = true;
                if (this.create) {
                    this.$store.dispatch('myPuzzles/create', [{
                        image: cropped
                    }])
                        .then(() => {
                            // TODO:
                            this.loader = false;
                            this.close();
                        })
                        .catch((err) => {
                            //console.log(err);
                            this.loader = false;
                        });
                } else {
                    // TODO: убрать
                    this.$store.dispatch('photos/update', [{
                        id: this.photoId,
                        image: cropped,
                        album: this.album
                    }])
                        .then(() => {
                            this.loader = false;
                            this.close();
                        })
                        .catch(() => {
                            this.loader = false;
                        });
                }
            }
        },
        close() {
            this.$modal.hide('crop-puzzle');
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/components/_cropper';
@import '~@/assets/styles/layout/_crop-puzzle';
</style>
